// extracted by mini-css-extract-plugin
export default {"row":"CardsRow_row__d6Q4v"};